import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_array } from "@swc/helpers/_/_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Translation } from '@core/locales';
import { Box, Center, Loader, Prompt, Stack, Text, factory } from '@coveord/plasma-mantine';
import { Children, isValidElement, useMemo } from 'react';
import { Locales } from '../../../../strings/Locales.js';
import { ProjectsList } from '../../ProjectsList.js';
import classes from './DeleteSingleResourcePrompt.module.css';
import { DeleteSingleResourcePromptCancelButton } from './DeleteSingleResourcePromptCancelButton.js';
import { DeleteSingleResourcePromptConfirmButton } from './DeleteSingleResourcePromptConfirmButton.js';
import { DeleteSingleResourcePromptHelpers } from './DeleteSingleResourcePromptHelpers.js';
var DeleteProjectsSection = function DeleteProjectsSection(param) {
    var projects = param.projects;
    var _projects_data;
    var cannotBeUndoneText = /*#__PURE__*/ _jsx(Text, {
        children: Locales.format('DeleteSingleResourcePrompt.description.projectSpecific.cannotBeUndone')
    });
    if (projects.isLoading) {
        return /*#__PURE__*/ _jsxs(Stack, {
            gap: "sm",
            pr: "xl",
            children: [
                /*#__PURE__*/ _jsx(Center, {
                    children: /*#__PURE__*/ _jsx(Loader, {})
                }),
                cannotBeUndoneText
            ]
        });
    }
    if (projects.isError) {
        return cannotBeUndoneText;
    }
    return /*#__PURE__*/ _jsxs(Stack, {
        gap: "sm",
        children: [
            ((_projects_data = projects.data) === null || _projects_data === void 0 ? void 0 : _projects_data.length) > 0 && /*#__PURE__*/ _jsx(ProjectsList, {
                items: projects.data
            }),
            cannotBeUndoneText
        ]
    });
};
export var DeleteSingleResourcePrompt = factory(function(_0, _1) {
    var _ref = [
        _0,
        _1
    ], _ref1 = _to_array(_ref), _ref2 = _ref1[0], _rest = _ref1.slice(1), additionalDescription = _ref2.additionalDescription, children = _ref2.children, onClose = _ref2.onClose, opened = _ref2.opened, _ref_projects = _ref2.projects, projects = _ref_projects === void 0 ? {
        isLoading: false,
        isError: false,
        data: []
    } : _ref_projects, resourceName = _ref2.resourceName, resourceType = _ref2.resourceType, promptProps = _object_without_properties(_ref2, [
        "additionalDescription",
        "children",
        "onClose",
        "opened",
        "projects",
        "resourceName",
        "resourceType"
    ]), _rest1 = _sliced_to_array(_rest, 1), ref = _rest1[0];
    var _ref3, _ref4;
    var _projects_data;
    var normalizedResourceName = (_ref3 = resourceName === null || resourceName === void 0 ? void 0 : resourceName.trim()) !== null && _ref3 !== void 0 ? _ref3 : '';
    var isProjectsError = (_ref4 = projects === null || projects === void 0 ? void 0 : projects.isError) !== null && _ref4 !== void 0 ? _ref4 : false;
    var hasProjectState = (projects === null || projects === void 0 ? void 0 : projects.isLoading) || isProjectsError || (projects === null || projects === void 0 ? void 0 : (_projects_data = projects.data) === null || _projects_data === void 0 ? void 0 : _projects_data.length) > 0;
    var promptButtons = useMemo(function() {
        return Children.toArray(children).filter(function(child) {
            return /*#__PURE__*/ isValidElement(child) && (child.type === DeleteSingleResourcePromptCancelButton || child.type === DeleteSingleResourcePromptConfirmButton);
        });
    }, [
        children
    ]);
    var descriptionKey = DeleteSingleResourcePromptHelpers.getSingleResourceDescription({
        hasProjectState: hasProjectState,
        isProjectsError: isProjectsError
    });
    return /*#__PURE__*/ _jsxs(Prompt, _object_spread_props(_object_spread({
        title: Locales.format('DeleteSingleResourcePrompt.title', {
            resourceType: resourceType
        }),
        variant: "critical",
        opened: opened,
        onClose: onClose,
        ref: ref
    }, promptProps), {
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                gap: "sm",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        children: /*#__PURE__*/ _jsx(Translation, {
                            t: Locales,
                            i18nKey: descriptionKey,
                            options: {
                                resourceType: resourceType,
                                resourceName: normalizedResourceName
                            },
                            children: /*#__PURE__*/ _jsx(Text, {
                                inherit: true,
                                span: true,
                                fw: 500,
                                className: classes.root
                            })
                        })
                    }),
                    hasProjectState && /*#__PURE__*/ _jsx(DeleteProjectsSection, {
                        projects: projects
                    }),
                    additionalDescription && /*#__PURE__*/ _jsx(Box, {
                        "data-testid": "delete-single-resource-prompt-additional-description",
                        children: additionalDescription
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Prompt.Footer, {
                children: promptButtons
            })
        ]
    }));
});
DeleteSingleResourcePrompt.CancelButton = DeleteSingleResourcePromptCancelButton;
DeleteSingleResourcePrompt.ConfirmButton = DeleteSingleResourcePromptConfirmButton;
DeleteSingleResourcePrompt.displayName = 'DeleteSingleResourcePrompt';

//# sourceMappingURL=DeleteSingleResourcePrompt.js.map